import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { IExistence, IItem, IWarehouse } from 'safe'
import InputCheck from '../../../components/Inputs/InputCheck'
import { ItemToTransfer } from './Transfers'
import placeholder from '../../../assets/images/img-placeholder.jpg'
import { AiOutlineBarcode } from 'react-icons/ai'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import axios from 'axios'
import { formatAmount } from '../../../utils/utils'
const server = process.env.REACT_APP_SERVER_URL

export const getStatusColors = (stock: number, minStock = 10) => {
  let colors = {
    text: 'text-green-800',
    value: 'text-green-700',
    bg: 'bg-green-200',
  }
  if (stock < minStock * 1.2 && stock > 0) {
    // 20%
    colors = {
      text: 'text-yellow-800',
      value: 'text-yellow-700',
      bg: 'bg-yellow-100',
    }
  } else if (stock <= 0) {
    colors = {
      text: 'text-red-700',
      value: 'text-red-700',
      bg: 'bg-red-200',
    }
  }
  return colors
}

const ShowExistence: React.FC<ShowExistenceProps> = ({
  itemsToTransfer,
  setItemsToTransfer,
  origin,
  notToShow,
  existences,
  setExistences,
  onChangeText
}) => {
  console.log("VER ITEMS TO TRANSFER", itemsToTransfer)
  const { addAlert } = useSnackBars()

  // const [existences, setExistences] = useState<any[]>([])

  // useEffect(() => {
  //   if (origin) fetchExistencesOnTheFly()
  // }, [origin])

  // const fetchExistencesOnTheFly = async (
  //   pattern: string = ''
  // ): Promise<void> => {
  //   // addAlert({
  //   //   message: 'Cargando Existencias...',
  //   //   status: 'loading',
  //   // })
  //   try {
  //     // const url =
  //     //   pattern === ''
  //     //     ? `${server}/inventory/existence/search/custom/${origin && origin.id
  //     //     }/`
  //     //     : `${server}/inventory/existence/search/custom/${origin && origin.id
  //     //     }?searchCustom=${pattern}`

  //     let response = await axios.get(`${server}/inventory/item/simple-search?param=${pattern}`)

  //     console.log("RESPONSE", response)

  //     setExistences(response.data.items?.map((x: any) => ({...x, checked: false})))
  //     addAlert({
  //       message: 'Existencias en origen Cargadas',
  //       status: 'success',
  //     })
  //   } catch (error: any) {
  //     addAlert({
  //       message: 'Error del servidor',
  //       status: 'error',
  //     })
  //   } 
  // }

  useEffect(() => {
    console.log("VER ITEMS TO TRANSFER", itemsToTransfer)
  }, [itemsToTransfer])

  const handleCheck = (newItem: IItem, index: number) => {
    // const newItemToTransfer: ItemToTransfer = {
    //   id: newItem.id,
    //   name: newItem.name,
    //   barcode: newItem.barcode,
    //   sku: newItem.sku,
    //   image: newItem.images[0]?.url,
    //   unit: newItem.unit,
    //   originAvailable: Number(originAvailable),
    //   quantity: 10,
    // }
    const copy = [...existences]
    copy[index].checked = !copy[index].checked
    setExistences(copy)
    const filtered = copy.filter((x) => x.checked)
    setItemsToTransfer(filtered)
    // if (!itemsToTransfer.find((item) => item.id === newItem.id)) {
    //   setItemsToTransfer((state) => [...state, newItem as any])
    // } else {  
    //   setItemsToTransfer((state) =>
    //     state.filter((item) => item.id !== newItem.id)
    //   )
    // }
  }
  
  if (origin) {
    return (
      <>
        {/* <label
          htmlFor="searchExistence"
          className="text-primary-900 dark:text-white"
        >
          Filtrar Artículo
        </label> */}
        <input
          type="text"
          className="dark:bg-gray-800 dark:text-white mt-1 mb-2"
          name="source"
          autoComplete="off"
          onChange={(e) => onChangeText(e.target.value)}
          // onChange={(e) => fetchExistencesOnTheFly(e.target.value)}
          placeholder="Filtrar Artículo"
          style={{ borderWidth: '0px' }}
        />
        {existences?.length === 0 && <p>No hay artículos para mostrar</p>}
        <div className="divide-y-2 divide-white h-80 overflow-y-scroll">
          { existences?.map((existence, index) => (
            <div key={existence.id}
            className="flex hover:bg-gray-50 items-center px-3 py-2 space-x-3  dark:bg-black overflow-auto"
            >
              <InputCheck
                  classes="mr-5"
                  // checked={itemsToTransfer.find(
                  //   (item) => item.id === existence.id
                  // )}
                  checked={existence?.checked}
                  onChange={() =>
                    handleCheck(existence, index)
                  }
                />
             <img
                  className="h-10 w-10 object-cover rounded-lg shadow-inner"
                  src={existence.image || placeholder}
                  alt={existence.image}
                />

              <div className="flex items-center space-y-1 justify-between md:space-x-3 flex-grow">
                  <div className=" ml-4">
                    <p className="font-semibold text-base text-gray-600 capitalize mb-2 dark:text-white">
                      {existence.name}
                    </p>
                    <div className="text-gray-400 flex items-center text-sm text-gray-500">
                      {/* {existence.barcode ? (
                        <>
                          <AiOutlineBarcode className="mr-1 mb-1 text-gray-400 inline" />
                          {existence.barcode}
                        </>
                      ) : (
                        'Sin código de barras'
                      )} */}
                    </div>
                  </div>
                  <div>
                    {/* <div
                      className={`${getStatusColors(+existence.quantity).bg
                        } text-right rounded-xl p-1 px-2 mb-1 min-w-max`}
                    >
                      <span
                        className={`${getStatusColors(+existence.quantity).text
                          } font-bold text-base`}
                      >
                        <b
                          className={`${getStatusColors(+existence.quantity).value
                            }  font-semibold`}
                        >
                          Disponible:
                        </b>{' '}
                        {formatAmount(existence.quantity, existence.item.unit)}
                      </span>
                    </div> */}
                    <p className="text-sm text-gray-500 text-right">
                      {existence.sku
                        ? `SKU: ${existence.sku}`
                        : 'Sin SKU'}
                    </p>
                  </div>
                </div>
            </div>
          )) }
          {/* {existences
            .filter(
              (existence) =>
                !notToShow.some((item) => item.id === existence.item.id)
            )
            .map((existence) => (
              <div
                key={existence.id}
                className="flex hover:bg-gray-50 items-center px-3 py-2 space-x-3  dark:bg-black overflow-auto"
              >
                <InputCheck
                  classes="mr-5"
                  checked={itemsToTransfer.find(
                    (item) => item.id === existence.item.id
                  )}
                  onChange={() =>
                    handleCheck(existence.item, existence.quantity)
                  }
                />
                <img
                  className="h-10 w-10 object-cover rounded-lg shadow-inner"
                  src={existence.item.images[0]?.url || placeholder}
                  alt={existence.item.sku}
                />
                <div className="flex items-center space-y-1 justify-between md:space-x-3 flex-grow">
                  <div className=" ml-4">
                    <p className="font-semibold text-base text-gray-600 capitalize mb-2 dark:text-white">
                      {existence.item.name}
                    </p>
                    <div className="text-gray-400 flex items-center text-sm text-gray-500">
                      {existence.item.barcode ? (
                        <>
                          <AiOutlineBarcode className="mr-1 mb-1 text-gray-400 inline" />
                          {existence.item.barcode}
                        </>
                      ) : (
                        'Sin código de barras'
                      )}
                    </div>
                  </div>
                  <div>
                    <div
                      className={`${getStatusColors(+existence.quantity).bg
                        } text-right rounded-xl p-1 px-2 mb-1 min-w-max`}
                    >
                      <span
                        className={`${getStatusColors(+existence.quantity).text
                          } font-bold text-base`}
                      >
                        <b
                          className={`${getStatusColors(+existence.quantity).value
                            }  font-semibold`}
                        >
                          Disponible:
                        </b>{' '}
                        {formatAmount(existence.quantity, existence.item.unit)}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 text-right">
                      {existence.item.sku
                        ? `SKU: ${existence.item.sku}`
                        : 'Sin SKU'}
                    </p>
                  </div>
                </div>
              </div>
            ))} */}
        </div>
      </>
    )
  }
  return <></>
}

export default ShowExistence

interface ShowExistenceProps {
  // existences: IExistence[]
  itemsToTransfer: ItemToTransfer[]
  setItemsToTransfer: Dispatch<SetStateAction<ItemToTransfer[]>>
  origin: IWarehouse | null
  notToShow: ItemToTransfer[]
  existences: any[]
  setExistences: any
  onChangeText: (text: string) => void
}
